import { getFormData } from "components/utils/comm";
import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";

export const onSubmit = (e: FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  // 데이터 가져오기
  const form = e.currentTarget;
  const formData = getFormData({ form, type: "C" });

  return formData;
};

// 상세

export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;
  const params = {
    no: props.data.manNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };
  setListRowParams(params);
};
